import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSubjects = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2799_10843",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_2799_10843)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M11 9.74995C11.4859 9.74995 11.899 9.57976 12.2394 9.23938C12.5798 8.89901 12.7499 8.48588 12.7499 7.99998C12.7499 7.51408 12.5798 7.10094 12.2394 6.76058C11.899 6.42019 11.4859 6.25 11 6.25C10.5141 6.25 10.1009 6.42019 9.76058 6.76058C9.42019 7.10094 9.25 7.51408 9.25 7.99998C9.25 8.48588 9.42019 8.89901 9.76058 9.23938C10.1009 9.57976 10.5141 9.74995 11 9.74995ZM11.0096 13.75C11.6634 13.75 12.2843 13.6189 12.8721 13.3567C13.4599 13.0945 13.9794 12.7198 14.4307 12.2327C13.8794 11.907 13.3166 11.6619 12.7423 11.4971C12.1679 11.3324 11.5904 11.25 11.0096 11.25C10.3711 11.25 9.75671 11.334 9.16632 11.5019C8.57594 11.6699 8.04678 11.9134 7.57885 12.2327C8.02372 12.7198 8.54166 13.0945 9.13268 13.3567C9.72371 13.6189 10.3494 13.75 11.0096 13.75ZM20.8884 20.9519L15.9096 15.973C15.2006 16.5384 14.4448 16.9759 13.6423 17.2855C12.8397 17.5951 11.959 17.75 11 17.75C8.83716 17.75 7.00479 16.999 5.50287 15.4971C4.00096 13.9952 3.25 12.1628 3.25 9.99998C3.25 7.83716 4.00096 6.00479 5.50287 4.50288C7.00479 3.00096 8.83716 2.25 11 2.25C13.1628 2.25 14.9952 3.00096 16.4971 4.50288C17.999 6.00479 18.75 7.83716 18.75 9.99998C18.75 10.959 18.5951 11.8413 18.2855 12.6471C17.9759 13.4529 17.5384 14.2102 16.973 14.9192L21.9423 19.8885L20.8884 20.9519ZM11 16.25C12.7307 16.25 14.2051 15.641 15.4231 14.4231C16.641 13.2051 17.25 11.7307 17.25 9.99998C17.25 8.26921 16.641 6.79484 15.4231 5.57688C14.2051 4.35893 12.7307 3.74995 11 3.74995C9.26921 3.74995 7.79484 4.35893 6.57687 5.57688C5.35892 6.79484 4.74995 8.26921 4.74995 9.99998C4.74995 11.7307 5.35892 13.2051 6.57687 14.4231C7.79484 15.641 9.26921 16.25 11 16.25Z",
			fill: "currentColor"
		})
	})]
});
export default SvgSubjects;
